import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
import { api } from "./api";

const RAZORPAY_SCRIPT_ID = "razorpay-checkout-script";

function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (document.getElementById(RAZORPAY_SCRIPT_ID)) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.id = RAZORPAY_SCRIPT_ID;
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export function useRazorpay() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();

  const openCheckout = async (plan) => {
    const loaded = await loadRazorpayScript();
    if (!loaded) {
      alert("Failed to load Razorpay. Please check your connection.");
      return;
    }

    let orderData;
    try {
      const res = await api.post("/payments/create-order", { plan_id: plan.id });
      orderData = res.data;
    } catch (err) {
      alert(err?.response?.data?.detail || "Failed to create order. Please try again.");
      return;
    }

    const options = {
      key: orderData.key_id,
      amount: orderData.amount,
      currency: orderData.currency,
      name: "Brainydo",
      description: plan.name,
      order_id: orderData.order_id,
      prefill: {
        name: user?.name || "",
        email: user?.email || "",
      },
      handler: async (response) => {
        try {
          await api.post("/payments/verify", {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            plan_id: plan.id,
          });
          await refreshUser();
          navigate("/app/dashboard");
        } catch (err) {
          alert(err?.response?.data?.detail || "Payment verification failed. Please contact support.");
        }
      },
      modal: {
        ondismiss: () => {},
      },
      theme: {
        color: "#2563EB",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return { openCheckout };
}
